<template>
    <div>
        <!-- 系统列表 -->
        <a-table id="myServiceTable" :columns="columns" :data-source="tableData" :scroll="{ x: clientWidth}"
            :pagination="false" :loading="tloading" rowKey="service">
            <!-- 报文 -->
            <template slot="readParams" slot-scope="text">
                <span v-if="text == 'yes'" style="color:green">是</span>
                <span v-else style="color:red">否</span>

            </template>
            
        </a-table>

    </div>
</template>
<script>


const columns = [
    { 
        title: '服务',
        dataIndex: 'service',
        align:'center',
        width:120,
    },
    { 
        title: '申请人', 
        dataIndex: 'applicant',
        align:'center',
        width:200, 
    },
    {
        title: '发布单提交',
        dataIndex: 'requested', 
        align:'center',
        scopedSlots: { customRender: 'readParams' },

        width:200
    },
    {
        title: '封板',
        dataIndex: 'block', 
        align:'center',
        scopedSlots: { customRender: 'readParams' },
        width:200
    },
    {
        title: '已发布',
        dataIndex: 'released', 
        align:'center',
        scopedSlots: { customRender: 'readParams' },

        width:200
    },
    {
        title: '创建时间',
        dataIndex: 'created', 
        align:'center',
        width:200
    },
    {
        title: '删除时间',
        dataIndex: 'deleted', 
        align:'center',
        width:200
    },

];

export default {
    data() {
        return {
            columns,
            tableData:[],
            tloading:false,
            clientWidth:800,
            searchP:{},
        };
    },
    methods: {
        getAppSumData(){
            let that = this
            let params = {
                ...that.searchP,
                ...that.pagination,
                urlparams:false
            };
            that.$store.dispatch({
                type: 'branch/getreleaserecords',
                params:params
            }).then((res)=>{
                if(res.status == 200 && res.data.success == '1'){
                    that.tableData = res.data.data;
                }
                that.tloading = false;
            }).catch(() => {
                that.tloading = false;

            });
        },
        handleSearch(searchP){
            this.searchP = searchP;
            this.getAppSumData();
        },
    },

    components:{
    },
    mounted(){
    }
};
</script>
<style scoped>
    .trend_pagination{
        margin-top: 10px;
    }

    .tableLink{
        margin-right: 10px;
    }

</style>

